import React from 'react';
import { useUser } from '@/contexts/AuthContext';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Badge, Avatar, styled } from '@mui/material';

const SmallAvatar = styled(Avatar)(({ theme, sizes }) => ({
  width: sizes === 'small' ? 26 : 35,
  height: sizes === 'small' ? 26 : 35,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const LargeAvatar = styled(Avatar)(({ theme, sizes }) => ({
  width: sizes === 'small' ? 60 : 72,
  height: sizes === 'small' ? 60 : 72,
  border: `2px solid ${theme.palette.background.paper}`,
}));

interface AvatarDashboardProps {
  sizes?: 'small' | 'big';
  hiddenSmallAvatar?: boolean;
}

export default function AvatarDashboard({
  sizes = 'small',
  hiddenSmallAvatar = true,
}: AvatarDashboardProps) {
  const { user, defaultMembership } = useUser();

  const companyLogo = defaultMembership?.company.logo;
  return (
    <>
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
          hiddenSmallAvatar && (
            <SmallAvatar
              sx={{
                backgroundColor: '#E9E9E9',
                color: '#C7C7C7',
                border: '1px solid currentColor',
              }}
              sizes={sizes}
              alt="Imagem pequena do usuário"
              src={(user?.avatar as string | undefined) || '#'}
            >
              {!user?.avatar && <PersonOutlineIcon sx={{ fontSize: '18px' }} />}
            </SmallAvatar>
          )
        }
      >
        <LargeAvatar
          sx={{
            backgroundColor: '#E9E9E9',
            color: '#C7C7C7',
            border: '1px solid currentColor',
          }}
          sizes={sizes}
          alt="Imagem grande da empresa"
          src={companyLogo || '#'}
        >
          {companyLogo && <StorefrontIcon sx={{ fontSize: '35px' }} />}
        </LargeAvatar>
      </Badge>
    </>
  );
}
